'use strict'

exports = module.exports = require('./commonjs/PhoneInputNativeDefaultMetadata').default
exports['default'] = require('./commonjs/PhoneInputNativeDefaultMetadata').default


//////////////////
// WEBPACK FOOTER
// ./~/react-phone-number-input/index.commonjs.js
// module id = 786
// module chunks = 0